<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Jumlah Penerima Sertifikat Penghargaan ({{ filterTahun }})</h2>

    <div class="d-inline-block px-3">
      <div class="d-flex align-items-center gap-2">
        <select v-model="filter.type" id="filter_type" class="form-select" style="width: 110px" @change="handleFilter">
          <option value="year">Tahun</option>
          <option value="month">Bulan</option>
        </select>
      </div>
    </div>
    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['filterTahun', 'filterBulan'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      filter: {
        type: 'year',
      },

      series: [
        {
          name: 'Jumlah Penerima Penghargaan',
          data: [0],
        },
      ],
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['0'],
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              colors: '#78909c',
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      },
    }
  },
  methods: {
    handleFilter() {
      this.getJumlahPenerimaPenghargaan()
    },

    async getJumlahPenerimaPenghargaan() {
      let val = {
        labels: ['0'],
        series: [0],
      }
      if (this.filter.type === 'year') {
        const res = await axios.get(
          `${this.baseapiPengendalian}api/dashboard/getJumlahSertifikatTahunan?tahun=${this.filterTahun}&bulan=${this.filterBulan}`,
          this.getApiOption(),
        )
        const resData = res.data.data

        val = {
          labels: resData.map((d) => d.tahun),
          series: resData.map((d) => d.jumlah),
        }
      } else {
        const res = await axios.get(
          `${this.baseapiPengendalian}api/dashboard/getJumlahSertifikatBulanan?tahun=${this.filterTahun}&bulan=${this.filterBulan}`,
          this.getApiOption(),
        )
        const resData = res.data.data

        val = {
          labels: resData.map((d) => d.nama_bulan),
          series: resData.map((d) => d.jumlah),
        }
      }

      this.series = [
        {
          name: 'Jumlah Penerima Penghargaan',
          data: val.series,
        },
      ]
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          categories: val.labels,
        },
      }
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  watch: {
    filterTahun: {
      handler() {
        this.getJumlahPenerimaPenghargaan()
      },
      immediate: true,
    },
    filterBulan() {
      this.getJumlahPenerimaPenghargaan()
    },
  },
}
</script>
